module.exports = __webpack_public_path__ + "static/media/new-york-48.d1376400.jpg";